import {
  CoreBroadcastChannelInterface,
  createCoreBroadcastChannel,
} from "@enfusion-ui/hooks";
import { noop } from "lodash";
import * as React from "react";

const INSPECTOR_CHANNEL_NAME = "inspector-channel";

export const CHANNELS = {
  [INSPECTOR_CHANNEL_NAME]: createCoreBroadcastChannel(INSPECTOR_CHANNEL_NAME, {
    webWorkerSupport: false,
  }),
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useBroadcastChannel<T = any>(
  name: keyof typeof CHANNELS,
  cb?: (msg: T) => void
) {
  React.useEffect(() => {
    let undoSub = noop;
    if (cb) {
      undoSub = CHANNELS[name].subscribe(cb);
    }
    return () => {
      undoSub();
    };
  }, [cb]);

  return CHANNELS[name] as CoreBroadcastChannelInterface<T>;
}
